import NetworkIcon from "@/components/icons/network"
import { Badge } from "@/components/ui/badge"
import { Network } from "@/config/tokens"

export default function NetworkBadge({ network }: { network: Network }) {
  return (
    <Badge
      variant="secondary"
      className="flex flex-row gap-2 font-normal text-sm w-fit"
    >
      <div className="w-4 h-4">
        <NetworkIcon name={network} />
      </div>
      {network.substring(0, 3)}
    </Badge>
  )
}
